module.exports = __webpack_public_path__ + "img/payment_providers.32441975.svg";